import React from 'react';
import ReactDOM from 'react-dom';
import { FaPalette, FaPencilRuler, FaBook, FaTimes } from 'react-icons/fa';
import './WelcomeModal.css';

const WelcomeModal = ({ onClose, onSelectTemplate, onCreateOwn, onShowTutorial }) => {
  const handleDontShowAgain = (e) => {
    if (e.target.checked) {
      localStorage.setItem('hideWelcomeModal', 'true');
    } else {
      localStorage.removeItem('hideWelcomeModal');
    }
  };

  return ReactDOM.createPortal(
    <div className="welcome-modal-overlay" onClick={onClose}>
      <div className="welcome-modal" onClick={e => e.stopPropagation()}>
        <button className="welcome-close-btn" onClick={onClose} title="ปิด">
          <FaTimes />
        </button>

        <div className="welcome-header">
          <h2>ยินดีต้อนรับสู่ PEA E-Poster</h2>
          <p>ระบบออกแบบโปสเตอร์อัตโนมัติ สำหรับการไฟฟ้าส่วนภูมิภาค</p>
        </div>

        <div className="welcome-preview">
          <div className="preview-poster">
            <div className="preview-header">Header</div>
            <div className="preview-gallery">Gallery</div>
            <div className="preview-detail">Detail</div>
            <div className="preview-footer">Footer</div>
          </div>
        </div>

        <div className="welcome-content">
          <h3>▶ เริ่มต้นอย่างไร?</h3>
          
          <div className="welcome-options">
            <button 
              className="welcome-option-card primary"
              onClick={() => {
                onSelectTemplate();
                onClose();
              }}
            >
              <div className="option-icon">
                <FaPalette />
              </div>
              <h4>ใช้เทมเพลต</h4>
              <p>เลือกเทมเพลตสำเร็จรูป<br />แก้ไขง่าย เหมาะกับมือใหม่</p>
              <span className="option-badge">แนะนำ</span>
            </button>

            <button 
              className="welcome-option-card"
              onClick={() => {
                onCreateOwn();
                onClose();
              }}
            >
              <div className="option-icon">
                <FaPencilRuler />
              </div>
              <h4>สร้างเอง</h4>
              <p>เริ่มจากหน้าว่าง<br />ออกแบบอิสระ เหมาะกับมืออาชีพ</p>
            </button>
          </div>
        </div>

        <div className="welcome-footer">
          <label className="welcome-checkbox">
            <input type="checkbox" onChange={handleDontShowAgain} />
            <span>ไม่แสดงอีก</span>
          </label>
          
          <div className="welcome-actions">
            <button 
              className="btn-tutorial"
              onClick={() => {
                onShowTutorial();
                onClose();
              }}
            >
              <FaBook /> ดูคู่มือ
            </button>
            <button className="btn-close-welcome" onClick={onClose}>
              เริ่มเลย
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default WelcomeModal;
